import { CategoryOutput } from 'dtos/shared/jobDetails';
import { CategoryStatus } from 'dtos/diligence/common';
import { makeAutoObservable, IReactionDisposer } from 'mobx';
import { LoadStatus } from 'utils/types';

export class DiligenceCategoryStore {
  private readonly disposers: IReactionDisposer[] = [];

  readonly title: string;
  readonly ask: string;
  status: CategoryStatus;

  saveStatusStatus: LoadStatus = 'none';
  showSuccess = false;

  constructor(private readonly category: CategoryOutput) {
    this.title = category.title;
    this.ask = category.ask;
    this.status = category.status;

    makeAutoObservable(this, {}, { autoBind: true });
  }

  destroy() {
    this.disposers.forEach((dispose) => dispose());
  }
}
